<div class="container pt-3">
  <ul class="nav nav-secondary mt-0 d-flex align-items-center justify-content-start gap-2">
    <a class="nav-item btn" [routerLink]="['/rewards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label class="mb-0">{{ 'rewards.nav.marketplace' | translate }}</label>
    </a>
    <a
      class="nav-item btn"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label class="mb-0">{{ 'rewards.nav.prize.draws' | translate }}</label>
    </a>
    <a
      class="nav-item btn"
      [routerLink]="['/rewards/auctions']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label class="mb-0">{{ 'rewards.nav.auctions' | translate }}</label>
    </a>

    <a
      class="nav-item btn d-none d-lg-block"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label class="mb-0">{{ 'rewards.nav.wallet' | translate }}</label>
    </a>
  </ul>
</div>
